import React from 'react';

import { Navigate, Outlet } from 'react-router-dom';
import NavBar from './NavBar';
import { isAuthenticated } from '../utils';
import Footer from './Footer';

export default function UnAuthLayout() {
  const { status } = isAuthenticated();

  return !status ? (
    <>
      <NavBar />
      <main className='min-h-[50dvh]'>
        <Outlet />
      </main>
      <Footer />
    </>
  ) : (
    <Navigate to={'/dashboard'} replace={true} />
  );
}
